export class ProjectListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            projects: lang.project[0],
            no: lang.project[1],
            projectCode: lang.project[2],
            projectClass: lang.project[198],
            projectCategory: lang.project[199],
            projectTitle: lang.project[3],
            customer: lang.project[14],
            responsible: lang.project[4],
            startDate: lang.project[25],
            closingDate: lang.project[26],
            completion: lang.project[27],
            margin: lang.project[191],
            action: lang.project[29],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            importTitle: lang.project[76],
            submit: lang.project[78],
            clickhere: lang.project[76],
            status: lang.project[73],
            payemntRefresh: lang.project[28],
            parentProjectCode: lang.project[208],
            expectedHours: lang.project[6],
            open: lang.general[99],
            closed: lang.general[100],
            search: lang.general[33],
            select_year: lang.general[96],
            not_invoiced: lang.project[153],
            invoiced_paid: lang.project[155],
            expected_delivery_date:lang.project[5],
            offer:lang.project[7],
            contract:lang.project[209],
            project_amount:lang.project[9],
            save:lang.general[0],
            requiredField: lang.general[26],
           
        }

    }

    lang() {
        return this.variables;
    }

}

export class ProjectViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            projects: lang.project[0],
            no: lang.project[1],
            projectCode: lang.project[2],
            projectClass: lang.project[198],
            projectCategory: lang.project[199],
            projectTitle: lang.project[3],
            customer: lang.project[14],
            responsible: lang.project[4],
            startDate: lang.project[25],
            closingDate: lang.project[26],
            completion: lang.project[27],
            margin: lang.project[191],
            action: lang.project[29],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            importTitle: lang.project[76],
            submit: lang.project[78],
            clickhere: lang.project[76],
            status: lang.project[73],
            payemntRefresh: lang.project[28],
            type: lang.project[69],
            topic: lang.project[68],
            description: lang.project[67],
            date: lang.project[21],
            addresser: lang.project[66],
            addressee: lang.project[100],
            attachments: lang.project[65],
            requiredField: lang.general[26],
            addProtocol: lang.project[128],
            save: lang.general[0],
            modify: lang.general[2],
            view: lang.general[3],
            erase: lang.general[4],
            exportCSV: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            editProtocol: lang.project[125],
            
           
        }

    }

    lang() {
        return this.variables;
    }

}

export class ProjectClassListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            projects: lang.project[0],
            no: lang.project[1],
            projectCode: lang.project[2],
            projectClass: lang.project[198],
            projectCategory: lang.project[199],
            projectTitle: lang.project[3],
            customer: lang.project[14],
            responsible: lang.project[4],
            startDate: lang.project[25],
            closingDate: lang.project[26],
            completion: lang.project[27],
            margin: lang.project[191],
            action: lang.project[29],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            importTitle: lang.project[76],
            submit: lang.project[78],
            status: lang.project[73],
            payemntRefresh: lang.project[28],
            parentProjectCode: lang.project[208],
            expectedHours: lang.project[6],
            description: lang.project[67],
            repetations: lang.project[104],
            daysnotify: lang.project[105],
            notificationTime: lang.project[114],
            erase: lang.general[4],
            modify: lang.general[2],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            importProjectClass: lang.project[206],
            clickHere: lang.project[77],
            save: lang.general[0],
            addprojectclass: lang.project[200],
            editprojectclass: lang.project[201],
            periodicRepetition: lang.project[202],
            yes: lang.project[203],
            nos: lang.project[204],
            selectTime: lang.general[32],
            requiredField: lang.general[26],
            select: lang.general[67],
            
           
        }

    }

    lang() {
        return this.variables;
    }

}